<template>
    <!-- ref="container" -->
  <v-dialog
    id="modal"
    v-model="showGuides"
    scrollable
    width="400"
    @keydown.esc="showGuides = false"
    @input="showGuides = false"
  >
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-btn text absolute right icon @click="showGuides = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-flex sm11>
            <h3 class="headline mb-0">{{ $t('TEMPLATE_GUIDE_TITLE') }}</h3>
            <p class="mb-0" v-nl2br>{{ $t('TEMPLATE_GUIDE_TAGLINE') }}</p>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex sm12>

<span v-if="debug">{{ fields }}</span>

            <v-list dense>
              <v-list-group
                v-for="(group, idx) in fields"
                :key="idx"
                v-model="groups[group.id]"
                :prepend-icon="group.icon"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ group.header }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item
                  v-if="!group.items.length"
                >
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ $t('SETTINGS_CONTACTS_ALL_SELECTED_HINT') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-for="item in group.items"
                  :key="item.id"
                  ripple
                  v-clipboard:copy="item.code"
                  @click="onSelect(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <!-- <v-btn v-if="isAvailableSelected(item)" icon @click.stop="onMoveRight()" color="primary"><v-icon>mdi-chevron-right</v-icon></v-btn> -->
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </v-list>

          </v-flex>
        </v-layout>
        <v-text-field v-model="selectedCode" ref="textToCopy"></v-text-field>
      </v-card-text>
      <div class="v-card-footer pa-3">
        <strong v-if="selected">{{ selected.label }} = {{ selected.code }}</strong>
        <p class="mb-0" v-nl2br>{{ $t('TEMPLATE_GUIDE_FOOTER') }}</p>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="showGuides = false">{{ $t('GENERIC_CLOSE') }}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MailingViewTemplateGuideDlg',
  props: ['visible', 'debug'],
  data() {
    return {
      fields: [],
      groups: [],
      selected: null,
      selectedCode: '',
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'data', 'settings']),
    showGuides: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    specialFields() {
      return [
        { id: 'id', value: 'id', code: '[f_id]', label: this.$t('TEMPLATE_GUIDE_ID') },
        { id: 'unsubscribe', value: 'unsubscribe', code: '[a_unsubscribe]', label: this.$t('TEMPLATE_GUIDE_UNSUBSCRIBE_LINK') },
        { id: 'date', value: 'date', code: '[a_date]', label: this.$t('TEMPLATE_GUIDE_CURRENT_DATE') },
        { id: 'loginname', value: 'loginname', code: '[a_loginname]', label: this.$t('TEMPLATE_GUIDE_LOGINNAME') },
        { id: 'webview', value: 'webview', code: '[a_webview]', label: this.$t('TEMPLATE_GUIDE_WEBVIEW') },
        // add more when needed in @it
        // { id: '_', value: '_', code: '[_]', label: this.$t('_') },
      ]
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    selected(val) {
      if (val) {
        this.onCopy()
      }
    },
  },
  mounted() {
    let fields = [], group

    group = {
      id: 'g1',
      icon: 'mdi-account-card-details',
      header: this.$t('CONTACT_STANDARD_FIELDS'),
      items: this.data.fields.map(a => ({ ...a, value: `i${a.value}`, label: this.$t(a.text), code: `[f_${a.id}]`, group: 'g1' })),
      // open: true,
    }
    // group.items.push({ "id": "country_name", "value": "country_name", "label": "Country Name", "text": "Country Name", "type": "field" })
    // group.items.push({ "id": "country_name", "value": "country_name", "label": this.$t('RESULTS_FIELD_COUNTRY_NAME'), "text": this.$t('RESULTS_FIELD_COUNTRY_NAME'), "type": "field", "field": })
    // group.items.sort((a, b) => ('' + a.label).localeCompare(b.label))
    fields.push(group)
    // this.$set(this.groups, 'g1', true) // is open
    this.$set(this.groups, 'g1', false) // is closed

    // group = {
    //   id: 'g2',
    //   icon: 'mdi-account-details',
    //   header: this.$t('CONTACT_CATEGORIES'),
    //   items: this.data.categories.map(a => ({ ...a, value: `c${a.value}`, code: `[c_${a.id}]`, group: 'g2' })),
    // }
    // group.items.sort((a, b) => ('' + a.label).localeCompare(b.label))
    // fields.push(group)
    // this.$set(this.groups, 'g2', false) // is closed

    group = {
      id: 'g3',
      icon: 'mdi-account-settings',
      header: this.$t('CONTACT_FREE_FIELDS'),
      items: this.data.custom_fields.map(a => ({ ...a, value: `f${a.value}`, code: `[fe_${a.id}]`, group: 'g3' })),
    }
    group.items.sort((a, b) => ('' + a.label).localeCompare(b.label))
    fields.push(group)
    this.$set(this.groups, 'g3', false) // is closed

    group = {
      id: 'g4',
      icon: 'mdi-account-star',
      header: this.$t('TEMPLATE_GUIDE_SPECIAL_FIELDS'),
      items: this.specialFields.map(a => ({ ...a, value: `s${a.value}`, group: 'g4' })),
    }
    group.items.sort((a, b) => ('' + a.label).localeCompare(b.label))
    fields.push(group)
    this.$set(this.groups, 'g4', false) // is closed

    this.fields = fields
  },
  methods: {
    onSelect(item) {
      this.selected = item
      this.selectedCode = item.code
    },
    onCopy() {
      // let that = this
      // if (this.selected && this.selected.code) {
      //   // let container = this.$refs.container
      //   let container = document.getElementById('modal');
      //   this.$copyText(this.selected.code, container).then(() => {
      //     that.$emit('success')
      //   }, error => {
      //     that.$emit('error')
      //     console.error(error)
      //   })
      // }

      // let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      // textToCopy.select()
      // document.execCommand("copy");

      let that = this
      if (this.selected && this.selected.code) {
        navigator.clipboard.writeText(this.selected.code).then(function() {
          that.$emit('success')
        }, function(error) {
          that.$emit('error')
          console.error(error)
        });
      }
    },
  }
}
</script>

<style>

</style>
